import PORTAL from "../portals/config.js";
import i18n from "../../i18n"

export default [
    {
        value: "retailerAttentionNeeded",
        label: i18n.t('flags.retailerAttentionRequired'),
        filterDefault: false
    },
    {
        value: "administratorAttentionNeeded",
        label: i18n.t('flags.adminAttentionRequired', {adminName: PORTAL.admin.name}),
        filterDefault: false
    }
]